import { render } from "./InstallVideoModal.vue?vue&type=template&id=ffd87808"
import script from "./InstallVideoModal.vue?vue&type=script&lang=js"
export * from "./InstallVideoModal.vue?vue&type=script&lang=js"
script.render = render

export default script